'use strict';

/* global $ */


import { interfaceName } from './settings';

// import { AjaxForm } from './modules/ajax-form';
// import { Form } from './modules/ajax-form/form';
// import { AjaxHandler } from './modules/ajax-handler';
// import { Map } from './modules/map';
import { Goal } from './modules/goal';
import { Responsive } from './modules/responsive';
// import { Header } from './modules/header';
// import { Earth } from './modules/earth';
// import { Examples } from './modules/examples';
// import { Faq } from './modules/faq';
// import { Geo } from './modules/geo';
import { Menu } from './modules/menu';
import { City } from './modules/city';
import { Player } from './modules/player';
// import { Resident } from './modules/resident';
// import { Playlist } from './modules/playlist';
import { Scroll } from './modules/scroll';
import { Slider } from './modules/slider';
// import { Tabs } from './modules/tabs';
import { Video } from './modules/video';


class Proj {
	constructor() {
		this.init();
	}
	init() {
		this.interfaceName = interfaceName;
		console.log('[ interfaceName ]', this.interfaceName);

		// this.ajaxForm = new AjaxForm();
		// this.ajaxHandler = new AjaxHandler();
		this.goal = new Goal({
			goals: [
				{
					selector: '.js-goal__link',
					event: 'click',
					handler: function() {
						$(window).trigger('main:reachGoal', $(this).data());
					}
				}, {
					selector: '.js-goal__form',
					event: 'submit',
					handler: function() {
						$(window).trigger('main:reachGoal', $(this).data());
					}
				}, {
					selector: window,
					event: 'goal ajaxForm:goal',
					handler: function(e, data) {
						$(window).trigger('main:reachGoal', data);
					}
				}
			]
		});

		this.responsive = new Responsive();
        // this.header = new Header({selector: '.js-header'});
        this.menu = new Menu({selector: '.js-menu'});
        this.city = new City({selector: '.js-city'});
        this.scroll = new Scroll({selector: '.js-scroll-to'});
        //this.geo = new Geo({selector: '.js-location'});

        //if (this.interfaceName === 'playlist_page') {
	    //    this.playlist = new Playlist({selector: '.js-playlist'});
        //}

        this.player = new Player({selector: '.js-player'});
        // this.resident = new Resident({selector: '.js-resident'});
        // this.globe = new Earth({selector: '.js-globe'});
        // this.examples = new Examples({selector: '.js-examples'});
        // this.faq = new Faq({selector: '.js-faq'});
        // this.tabs = new Tabs({selector: '.js-tabs'});
        /*
        this.areasSlider = new Slider({
            selector: '.js-areas__slider',
            show: 1,
            scroll: 1,
            //arrows: true,
            dots: false,
            fade: true,
            autoplay: false,
            //autoplayspeed: 5000,
            //nav: '.js-areas__slider',
            slide: '.slider__item',
            prev: '.js-areas__slider-prev',
            next: '.js-areas__slider-next',
            rows: 0,
            perrorw: 1,
            //adaptiveheight: false,
            //init: function(event, slick) {
            //},
            before: function(event, slick, currentSlide, nextSlide) {
            	console.log(slick, currentSlide, nextSlide);
            	let slide = slick.$slides[nextSlide];
            	let currentId = $(slick.$slides[currentSlide]).data('region_id')
            	let nextId = $(slick.$slides[nextSlide]).data('region_id')
            	$('.js-areas__region[data-region_id=' + currentId + ']').addClass('is-hidden');
            	$('.js-areas__region[data-region_id=' + nextId + ']').removeClass('is-hidden');
            },
            //after: function(slick, currentSlide) {
            //	console.log(currentSlide);
            //},
        });

        this.merchSlider = new Slider({
            selector: '.js-merch__item-slider',
            show: 1,
            scroll: 1,
            //arrows: true,
            dots: true,
            fade: true,
            autoplay: false,
            //autoplayspeed: 5000,
            //nav: '.js-areas__slider',
            slide: '.slider__item',
            //prev: '.js-areas__slider-prev',
            //next: '.js-areas__slider-next',
            rows: 0,
            perrorw: 1,
            //adaptiveheight: false,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //	console.log(currentSlide);
            //},
        });

        this.merchGalleryMain = new Slider({
            selector: '.js-merch__gallery-picture',
            show: 1,
            scroll: 1,
            arrows: true,
            //dots: true,
            fade: true,
            autoplay: false,
            //autoplayspeed: 5000,
            //nav: '.js-merch__gallery-picture-nav',
            slide: '.slider__item',
            prev: '.js-merch__gallery-picture-prev',
            next: '.js-merch__gallery-picture-next',
            rows: 0,
            perrorw: 1,
            asnavfor: '.js-merch__gallery-thumbs'
            //adaptiveheight: false,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //	console.log(currentSlide);
            //},
        });

        this.merchGalleryThumbs = new Slider({
            selector: '.js-merch__gallery-thumbs',
            show: 3,
            scroll: 1,
            //arrows: true,
            //dots: true,
            //fade: true,
            autoplay: false,
            //autoplayspeed: 5000,
            //nav: '.js-areas__slider',
            slide: '.slider__item',
            //prev: '.js-areas__slider-prev',
            //next: '.js-areas__slider-next',
            rows: 0,
            perrorw: 1,
            vertical: true,
            verticalswiping: true,
            asnavfor: '.js-merch__gallery-picture',
            //adaptiveheight: false,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //	console.log(currentSlide);
            //},
        });

        this.merchTabsSlider = new Slider({
            selector: '.js-tabs__slider',
            show: 1,
            scroll: 1,
            variablewidth: true,
            arrows: true,
            //infinite: false,
            //dots: true,
            //fade: true,
            autoplay: false,
            //autoplayspeed: 5000,
            //nav: '.js-areas__slider',
            slide: '.slider__item',
            prev: '.js-tabs__menu-prev',
            next: '.js-tabs__menu-next',
            rows: 0,
            perrorw: 1,
            //adaptiveheight: false,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //	console.log(currentSlide);
            //},
        });

        this.gameSchedule = new Slider({
            selector: '.js-games__schedule',
            show: 1,
            scroll: 1,
            arrows: true,
            //dots: true,
            //fade: true,
            autoplay: false,
            infinite: true,
            //centermode: true,
            //autoplayspeed: 5000,
            //nav: '.js-areas__slider',
            slide: '.slider__item',
            prev: '.js-games__schedule-prev',
            next: '.js-games__schedule-next',
            rows: 0,
            perrorw: 1,
            vertical: true,
            verticalswiping: true,
            variableheight: true,
            //asnavfor: '.js-merch__gallery-picture',
            //adaptiveheight: true,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //	console.log(currentSlide);
            //},
        });
        */
        this.newsGallery = new Slider({
            selector: '.js-news__gallery .slider',
            show: 1,
            scroll: 1,
            arrows: true,
            fade: true,
            autoplay: false,
            slide: '.slider__item',
            prev: '.js-news__gallery-prev',
            next: '.js-news__gallery-next',
            rows: 0,
            perrorw: 1,
        });
	}
}

$(function() {
	window.proj = new Proj();
});
